import LazyYouTube from "./LazyYouTube";

const RentVenue = () => {
  return (
    <section className="py-24 px-4 bg-background">
      <div className="max-w-5xl mx-auto space-y-12">
        <div className="text-center space-y-4">
          <h2 className="text-3xl md:text-4xl font-semibold text-primary">
            Deine ganz eigene Feier
          </h2>
          <p className="text-foreground/70 text-lg max-w-2xl mx-auto leading-relaxed">
            Ob Geburtstag, Firmenfeier, Jubiläum oder einfach ein Anlass zum Feiern –
            der Luther Club bietet dir den perfekten Rahmen.
          </p>
        </div>

        {/* Video – 16:9 */}
        <div className="relative w-full aspect-video rounded-lg overflow-hidden border border-border/30">
          <LazyYouTube
            videoId="AM3Mc6Ahg_s"
            title="Luther Club Location"
            className="absolute inset-0 w-full h-full"
          />
          <div className="absolute inset-0" />
        </div>

        {/* Text */}
        <div className="max-w-3xl mx-auto space-y-6 text-center">
          <p className="text-foreground/80 text-lg leading-relaxed">
            Mit Platz für bis zu <span className="text-primary font-semibold">450 Gäste</span>,
            professionellem Soundsystem, Lichtanlage und eigener Bar wird dein Abend unvergesslich.
          </p>
          <p className="text-foreground/70 leading-relaxed">
            Catering, Showacts, Bands, DJs, individuelle Getränkepakete, Dekoration –
            wir kümmern uns um alles. Von der ersten Idee bis zur kompletten Eventplanung
            steht unser Team an deiner Seite. Du feierst, wir machen den Rest.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 font-[Montserrat] text-sm tracking-[0.15em] uppercase px-8 py-3 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors"
          >
            Anfrage senden
          </a>
        </div>
      </div>
    </section>
  );
};

export default RentVenue;
